// import { Models } from '../date/DateTypes'

const locale = {
  title: '日期选择',
  today: '今天',
  month: '月',
  year: '年',
  am: '上午',
  pm: '下午',
  dateTimeFormat: 'yyyy年MM月dd日 星期w hh:mm',
  dateFormat: 'yyyy年MM月dd日 星期w',
  noChoose: '未选择',
  week: ['日', '一', '二', '三', '四', '五', '六'],
  clear: '清除',
  selectTime: '选择时间',
  selectStartTime: '选择开始时间',
  selectEndTime: '选择结束时间',
  start: '开始',
  end: '结束',
  begin: '起',
  over: '止',
  begin_over: '起/止',
  confirm: '确认',
  monthTitle: 'yyyy年MM月',
  loadPrevMonth: '加载上一个月',
  yesterday: '昨天',
  lastWeek: '近一周',
  lastMonth: '近一个月'
}
export default locale



// WEBPACK FOOTER //
// ./src/components/mobile-calendar/locale/zh_CN.js